import type { ICellRendererParams } from 'ag-grid-community';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { ScheduledSemenItem } from '@/services/semen-pull';
import { useCrmUrl } from '@/utils/crm-url';

export const ScheduledSemenTypeCell = ({
  value,
  data,
}: ICellRendererParams<ScheduledSemenItem>) => {
  const isNucleusLinkEnabled = useFeatureFlag('Semen_Type_Hyperlink');
  const crmUrl = useCrmUrl();

  if (isNucleusLinkEnabled) {
    if (!data?.semenId) {
      return value;
    }

    return (
      <a
        href={`/semen/detail?semenId=${data.semenId}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {value}
      </a>
    );
  }

  if (!crmUrl) {
    return value;
  }

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10029');
  url.searchParams.set(
    'extraqs',
    'formid=2d624d97-c1df-4829-be50-f32cd3e5f3bc',
  );
  url.searchParams.set('id', `{${data?.semenId}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
